<template>
  <div v-if="isAuth" class="container advancedSettings">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ device.data.name }}
    </h1>

    <div class="buttons is-pulled-right">
      <a class="button is-success" @click="save">{{ $t("buttons.save") }}</a>
      <a class="button is-success" @click="changePassword">{{
        $t("userMode.changePassword.button")
      }}</a>
    </div>

    <h2 class="subtitle">{{ $t("userMode.label") }} {{ device.data.name }}</h2>
    <br />

    <div class="columns">
      <div class="column">
        <div class="field">
          <b-switch v-model="form.user_mode" type="is-success">{{
            $t("userMode.activate")
          }}</b-switch>
        </div>

        <div class="field">
          <label
            >{{ $t("statistics.temperature_min") }}
            {{ form.um_min_temp }} º</label
          >

          <br /><br />
          <range-input
            :min="ranges.min.min"
            :max="ranges.min.max"
            v-model="form.um_min_temp"
          >
            <template slot="start">
              <span class="rangeMin">{{ ranges.min.min }} º</span>
            </template>
            <template slot="end">
              <span class="rangeMax">{{ ranges.min.max }} º</span>
            </template>
          </range-input>
        </div>

        <div class="field">
          <label
            >{{ $t("statistics.temperature_max") }}
            {{ form.um_max_temp }} º</label
          >

          <br /><br />
          <range-input
            :min="ranges.max.min"
            :max="ranges.max.max"
            v-model="form.um_max_temp"
          >
            <template slot="start">
              <span class="rangeMin">{{ ranges.max.min }} º</span>
            </template>
            <template slot="end">
              <span class="rangeMax">{{ ranges.max.max }} º</span>
            </template>
          </range-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import constants from "@/config/constants";
import RangeInput from "@/components/shared/RangeInput.vue";

export default {
  name: "device-user-mode",
  components: {
    RangeInput,
  },
  data() {
    return {
      form: {},
      isAuth: false,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
    }),

    ...mapState("zones", {
      zone: "current",
    }),

    ...mapState("devices", {
      device: "current",
    }),

    ranges: function () {
      return {
        min: {
          min:
            this.device.data.type === constants.deviceTypes.acs
              ? constants.ranges.eco.acs.min
              : constants.ranges.eco.radiator.min,
          max:
            this.device.data.type === constants.deviceTypes.acs
              ? constants.ranges.eco.acs.max
              : constants.ranges.eco.radiator.max,
        },

        max: {
          min:
            this.device.data.type === constants.deviceTypes.acs
              ? constants.ranges.comfort.acs.min
              : constants.ranges.comfort.radiator.min,
          max:
            this.device.data.type === constants.deviceTypes.acs
              ? constants.ranges.comfort.acs.max
              : constants.ranges.comfort.radiator.max,
        },
      };
    },
  },
  methods: {
    goBack: function () {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
          "/device/" +
          this.device.serialnumber +
          "/settings"
      );
    },

    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
    }),

    ...mapActions("devices", {
      setAdvancedSettings: "setAdvancedSettings",
      setDevice: "setCurrent",
      setUserMode: "setUserMode",
      setUserModePassword: "setUserModePassword",
    }),

    changePassword: function () {
      while (true) {
        let password = prompt(
          this.$t("userMode.changePassword.newPasswordLabel")
        );
        if (password !== null && password.length > 3) {
          this.setUserModePassword({ device: this.device, password: password });
          break;
        } else if (password === null) {
          break;
        } else {
          alert(this.$t("userMode.changePassword.passwordPattern"));
        }
      }
    },

    auth: function () {
      this.isAuth = true;

      while (true) {
        let password = prompt(this.$t("userMode.auth.enterPassword"));
        if (password !== null && password.length > 0) {
          let match =
            this.device.data.um_password !== undefined
              ? this.device.data.um_password
              : "0000";
          if (password === match) {
            this.isAuth = true;
            break;
          } else {
            alert(this.$t("userMode.auth.invalidPassword"));
          }
        } else {
          this.goBack();
          break;
        }
      }
    },

    fillForm: function () {
      this.form = {
        user_mode: this.device.data.user_mode
          ? this.device.data.user_mode
          : false,
        um_min_temp: this.device.data.um_min_temp
          ? this.device.data.um_min_temp
          : this.device.type === constants.deviceTypes.acs
          ? constants.acsDefaultEco
          : constants.defaultEco,
        um_max_temp: this.device.data.um_max_temp
          ? this.device.data.um_max_temp
          : this.device.type === constants.deviceTypes.acs
          ? constants.acsDefaultComfort
          : constants.defaultComfort,
      };
    },

    save: function () {
      this.setUserMode({ device: this.device, form: this.form });
    },
  },

  mounted() {
    this.setInstallation(this.$route.params.id)
      .then(() => {
        this.setZone(this.$route.params.idZone).then(() =>
          this.setDevice(this.$route.params.idDevice).then(() => {
            this.fillForm();
            this.auth();
          })
        );
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}

.advancedSettings {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}

.advancedSettings .columns {
  border-radius: 0;
}

.advancedSettings .columns:nth-child(3) {
  border-radius: 15px 15px 0 0;
}

.advancedSettings .columns:last-child {
  border-radius: 0 0 15px 15px;
}

div.input {
  padding: 5px;
  background-color: white;
  border: 1px solid #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  border-radius: 4px;

  label {
    cursor: auto;
  }
}

.rangeMax {
  margin-left: 5%;
}

.rangeMin {
  margin-right: 5%;
}
</style>
